// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".gift-section[data-v-4d399f1f] {\n  flex: 1;\n}\n", "",{"version":3,"sources":["webpack://./src/features/gift/GiftSection.vue"],"names":[],"mappings":"AAEA;EACE,OAAA;AADF","sourcesContent":["@import \"@/assets/styles/mixin.less\";\n\n.gift-section {\n  flex: 1;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
